"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Image16Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M6.80507368,9.55918636 L8.83066723,6.55693424 C8.89716808,6.45045441 8.98482301,6.35824291 9.0887493,6.28641343 C9.52280129,5.98641497 10.1121684,6.11475403 10.3885083,6.55722411 C10.5458507,6.80939728 10.7228509,7.08718805 10.9681746,7.46819539 C10.9994257,7.51673083 11.4720511,8.24912136 11.6134867,8.46941013 C11.7071748,8.61545111 11.7071748,8.61545111 11.8007895,8.76197433 C12.1204938,9.26297804 12.3806264,9.68012318 12.6107557,10.063787 L11.2386583,10.8867989 C11.0172655,10.5177004 10.7644299,10.1122567 10.4520098,9.6226678 C10.3597474,9.47826115 10.3597474,9.47826115 10.2671048,9.33384962 C10.1268681,9.11542819 9.65506113,8.38430604 9.62291637,8.33438266 C9.61274051,8.31857873 9.60267898,8.30294745 9.5927284,8.28748339 L7.08113437,12.0109362 L5.22090131,10.2672776 L3.39466675,13 L12.9921309,13 L12.9994377,3 L3,3 L3,8 L1,8 L1,1 L15,1 L15,15 L1.97195744,15 C1.72470197,14.9753726 1.72470197,15.1169068 1.50544284,15 C1.11990477,14.7423511 1.01623012,13.6794108 1.27387903,13.2938728 L4.32536736,8.72828492 C4.39123188,8.62347296 4.47763603,8.53257725 4.5798982,8.46146031 C4.97109565,8.18940691 5.49002184,8.26628996 5.79126088,8.60890571 L6.80507368,9.55918636 Z", id: `image16-${id0}` })),
        react_1.default.createElement("g", { id: "image-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#image16-${id0}` })),
            react_1.default.createElement("use", { id: "Path", fill: "#000000", fillRule: "nonzero", xlinkHref: `#image16-${id0}` })));
}
function Image16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Image16Svg, Object.assign({}, svgProps)));
}
exports.default = Image16;
//# sourceMappingURL=Image16.js.map